import { ClassifiedAdoptBlock } from '../../rest/types/Classified'

export function BlockAdoptTransformer({
  block,
  t,
}: {
  block: ClassifiedAdoptBlock
  t: any
}) {
  return {
    ...(block?.speciality?.name && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.speciality?.name
            ? [
                {
                  title: t('ads_types_speciality_title'),
                  text: block?.speciality?.name,
                },
              ]
            : []),
        ],
      },
    }),

    adsHighlight: {
      title: t('ads_highlight_adopt_title'),
      text: t('ads_highlight_adopt_text'),
      button: {
        label: t('ads_highlight_button_label'),
        href: t('ads_intro_link_href_adopt'),
      },
    },
  }
}
